import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';

import { messages } from './messages';
import type { CustomizeButtonsProps } from './types';

export function CustomizeButtons({
	isCustomizing,
	setIsCustomizing,
	onCancel,
	onApply,
}: CustomizeButtonsProps): React.JSX.Element {
	const intl = useIntl();

	const onClickCustomizeButton = useCallback(() => {
		setIsCustomizing(true);
	}, [setIsCustomizing]);

	const onClickCancelButton = useCallback(() => {
		setIsCustomizing(false);
		onCancel();
	}, [onCancel, setIsCustomizing]);

	const onClickApplyButton = useCallback(() => {
		setIsCustomizing(false);
		onApply();
	}, [onApply, setIsCustomizing]);

	if (isCustomizing) {
		return (
			<>
				<Button onClick={onClickCancelButton}>
					{intl.formatMessage(messages.cancelButtonLabel)}
				</Button>
				<Button appearance="primary" onClick={onClickApplyButton}>
					{intl.formatMessage(messages.applyButtonLabel)}
				</Button>
			</>
		);
	}

	return (
		<Button onClick={onClickCustomizeButton}>
			{intl.formatMessage(messages.customizeButtonLabel)}
		</Button>
	);
}
